import React from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { External } from '@fabric-ui/icons';
import { getMitreLink } from '@fabric-ui/utils';
import { Button } from '@mui/material';

interface MitreButtonProps {
  tacticId: string;
  techniqueId: string;
  // TODO: remove after useMitreObj is moved too
  mitreMap: { [key: string]: string };
}

const externalIcon = <External />;

export const MitreButton: React.FC<MitreButtonProps> = ({ tacticId, techniqueId, mitreMap }) => {
  const mitreId = `${tacticId}|${techniqueId}`;
  const mitreLabel = mitreMap[mitreId] || `${tacticId} - ${techniqueId}` || '';
  return (
    <AvTooltip title="Read more about this MITRE attack">
      <Button target="_blank" href={getMitreLink(techniqueId)} variant="external">
        {mitreLabel}
        {externalIcon}
      </Button>
    </AvTooltip>
  );
};
